package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ClassSectionCreateRequest(
    @SerialName("school_id")
    val schoolId: String,
    @SerialName("academic_year_id")
    val academicYearId: String,
    @SerialName("class_name")
    val className: String,
    @SerialName("section_name")
    val sectionName: String,
    @EncodeDefault
    @SerialName("is_active")
    val isActive: Boolean = true
)

@Serializable
data class ClassSectionWithSubjectsCreateRequest(
    @SerialName("academic_year_id")
    val academicYearId: String,
    @SerialName("class_name")
    val className: String,
    @SerialName("section_name")
    val sectionName: String,
    @EncodeDefault
    @SerialName("is_active")
    val isActive: Boolean = true,
    @SerialName("subject_ids")
    val subjectIds: List<String> = emptyList()
)

@Serializable
data class ClassSectionUpdateRequest(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("academic_year_id")
    val academicYearId: String? = null,
    @SerialName("class_name")
    val className: String? = null,
    @SerialName("section_name")
    val sectionName: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null
)

@Serializable
data class ClassSectionFilterRequest(
    @SerialName("classId")
    val classId: String? = null,
    @SerialName("sectionId")
    val sectionId: String? = null,
    @SerialName("subjectCode")
    val subjectCode: String? = null,
    @SerialName("status")
    val status: String? = null,
    @SerialName("createdDateFrom")
    val createdDateFrom: String? = null,
    @SerialName("createdDateTo")
    val createdDateTo: String? = null
)

@Serializable
data class ClassSubjectLinkCreateRequest(
    @SerialName("class_section_id")
    val classSectionId: String,
    @SerialName("subject_id")
    val subjectId: String,
    @EncodeDefault
    @SerialName("is_active")
    val isActive: Boolean = true
)

@Serializable
data class ClassSubjectLinkUpdateRequest(
    @SerialName("class_section_id")
    val classSectionId: String? = null,
    @SerialName("subject_id")
    val subjectId: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null
)
